import { useEffect, useState } from 'react';

// Components
import { Grid } from '@mui/material';
import { SelectInput } from '../SelectInput';

// Services
import { WorkflowApi } from '../../services/WorkflowApi';

// Styles

// Icons

// Utils
import { useTranslation } from 'react-i18next'
import { CheckResponse } from '../../utils/checkResponse';
import { CustomButtonV2, CustomFormLabel } from '../../pages/styles';
import { toast } from 'react-toastify';

// Permissions
import { useAbility } from '@casl/react';
import { AbilityContext } from '../../Context/PermissionsContext';
import { SaveOutlined } from '@mui/icons-material';

export const GeneralSettings = (props) => {

    const workflowApi = new WorkflowApi();
    const {check} = new CheckResponse();
    const { t } = useTranslation();
    const ability = useAbility(AbilityContext);

    const [workflowList, setWorkflowList] = useState([])
    const [selectedWorkflow, setWelectedWorkflow] = useState({})

    useEffect(() => {
        async function call() {
            await callWorkflowApi()
        }
        call()
    }, [])

    async function callWorkflowApi() {
        let response = await workflowApi.list();
        let result = check(response);

        if (result.status) {
            let defaultWorkflow = response.data.find((el) => el.default)
            if (defaultWorkflow?.id) setWelectedWorkflow(defaultWorkflow)
            else setWelectedWorkflow(response.data.find((el) => el.id === 1))
            setWorkflowList(response.data)
        }
    }

    async function save() {
        if (!selectedWorkflow.id) {
            toast.error(t('settings.validations.mandatoryFlow'))
            return
        }

        let response = await workflowApi.workflowDefault(selectedWorkflow.id);
        let result = check(response);

        if (result.status) {
            toast.success(t('settings.messages.saveWorkflow.title'))
        }
        else {
            toast.error(() => 
                <div>{t('settings.messages.saveWorkflow.error')}<br/>
                    {result.errors}
                </div>
            );
        }  
    }

    return (
        <Grid container spacing={2} justifyItems={'center'} alignItems={'center'}>
            <Grid item xs={12} sm={8} md={6} lg={5} xl={4}>
				<CustomFormLabel>{t('settings.defaultFlow')}</CustomFormLabel>
                <SelectInput
                    name='workflow'
                    onChange={e => setWelectedWorkflow(e)}
                    value={selectedWorkflow} 
                    keyValue="name"
                    options={workflowList}
                    size="small"
                />
            </Grid>

            {ability.can("DefaultWorkflow") &&
				<>
				<Grid item xs={8} sm={10} xl={11}></Grid>
                <Grid item xs={4} sm={2} xl={1} direction='row' justifyContent="flex-end">
                    <CustomButtonV2
                        btnType="primary"
                        onClick={save}
						startIcon={<SaveOutlined/>}
                    >
                        {t('common.save')}
                    </CustomButtonV2>
                </Grid>
				</>
            }
        </Grid>
    )
}
